export const INTERPRETER_STATUS_CONNECTED = 'Connected';
